<template>
    <div>
        <div style="margin-top: 25px;">
            <el-row :gutter="12">
                <el-col :span="4">
                    <el-button type="primary" @click="openDialog">运营商充值</el-button>
                </el-col>
                <el-col :span="20">
                    <div style="width: 100%;text-align: right;">
                        <el-date-picker
                                        style="width: 255px;margin-left: 3px;"
                                        v-model="time"
                                        type="daterange"
                                        range-separator="至"
                                        start-placeholder="充值开始日期"
                                        end-placeholder="充值结束日期"
                                        format="yyyy-MM-dd">
                        </el-date-picker>
                        <el-button type="primary" style="margin-left: 3px;" icon="el-icon-search" @click="updateTable">
                            搜索</el-button>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div style="margin-top: 15px;">
            <el-table ref="multipleTable"
                      :data="tableData"
                      style="width: 100%"
                      element-loading-text="数据正在加载中"
                      @selection-change="handleSelectionChange"
                      :header-cell-style="headClass"
                      :row-style="rowClass">
                <el-table-column type="selection" width="60"></el-table-column>
                <el-table-column prop="payId" label="充值单号"></el-table-column>
                <el-table-column prop="payType" label="类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.payType === 1002">充值</span>
                        <span v-if="scope.row.payType === 1009">押金</span>
                    </template>
                </el-table-column>
                <el-table-column prop="agentId" label="运营商ID"></el-table-column>
                <el-table-column prop="agentName" label="运营商姓名"></el-table-column>
                <el-table-column prop="money" label="充值金额"></el-table-column>
                <el-table-column prop="posttime" label="时间" :formatter="dateFormat"></el-table-column>
                <el-table-column prop="remarks" label="备注"></el-table-column>
            </el-table>
            <el-pagination background
                           style="text-align:right;margin-top: 15px;margin-bottom: 55px;"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="currentPage"
                           :page-sizes="[10, 50, 100, 200]"
                           :page-size="pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </div>
        <el-dialog title="运营商充值" :visible.sync="myDialog" width="400px" :close-on-click-modal="false">
            <el-form label-position="right" label-width="66px" ref="rechargeForm" :rules="rechargeRules"
                     :model="rechargeForm">
                <el-form-item label="运营商" prop="companySelect" placeholder="请选择运营商">
                    <el-select v-model="rechargeForm.companySelect" style="width: 260px;">
                        <el-option :value="item.agentId" :label="item.companyName" style="height: 40px;font-size: 11px;"
                                   v-for="item in companyList">
                            <el-row style="height: 20px;font-size: 10px;">
                                <el-col :span="24" style="line-height: 20px;height: 20px;">{{item.companyName}}</el-col>
                            </el-row>
                            <el-row style="height: 20px;">
                                <el-col :span="8" style="line-height: 20px;height: 20px;">{{item.name}}</el-col>
                                <el-col :span="16" style="line-height: 20px;height: 20px;">{{item.phone}}</el-col>
                            </el-row>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-popover
                            ref="popover"
                            placement="top"
                            width="222"
                            trigger="focus"
                            :content="initMoney">
                </el-popover>
                <el-form-item label="类型" prop="type">
                    <el-select v-model="rechargeForm.type" placeholder="" style="width: 260px;">
                        <el-option label="充值" value="0"></el-option>
                        <el-option label="首次充值" value="1"></el-option>
                        <el-option label="押金" value="2"></el-option>
                    </el-select>
                    <el-tooltip class="item" effect="light" content="“首次充值”会对其上级代理商进行招商奖励" placement="right-start">
                        <i class="el-icon-question" />
                    </el-tooltip>
                </el-form-item>
                <el-form-item label="金额" prop="money">
                    <el-input v-model="rechargeForm.money" style="width: 260px;" placeholder="请输入金额" v-popover:popover
                              :disabled="changeMoney"></el-input>
                </el-form-item>

                <el-form-item prop="randomcode" label="验证码">
                    <el-row :gutter="15">
                        <el-col :span="12">
                            <el-input v-model="rechargeForm.randomcode" placeholder="请输入验证码"></el-input>
                        </el-col>
                        <el-col :span="6">
                            <el-button id="getVerifyCode" type="warning" @click="getVerifyCode">获取验证码</el-button>
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input v-model="rechargeForm.remark" type="textarea" :rows="3" style="width: 260px;"
                              placeholder="请输入备注"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="myDialog = false">取 消</el-button>
                <el-button type="primary" @click="addMoney">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: 'agentRecharge',
        components: {},
        data() {
            var validMoney = (rule, value, callback) => {
                var regPos = /((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/;
                var temp = (value.indexOf(".") != -1) ? value.substring(0, value.indexOf(".")) : value;
                if (temp.length >= 10) {
                    callback(new Error('输入金额不应大于10亿!'));
                } else if (value <= 0) {
                    callback(new Error('输入金额应大于0元!'));
                } else if ((value.charAt(0) == '0' && value.indexOf(".") != 1) || !regPos.test(value) || value
                    .indexOf(".") == value.length - 1) {
                    callback(new Error('请输入正确格式的金额!金额最多保留两位小数.'));
                } else {
                    callback();
                }
            }
            return {
                total: 0,
                currentPage: 1,
                pageSize: 10,
                tableData: [],
                multipleSelection: [],
                selectValue: "",
                queryValue: "",
                companyList: [],
                myDialog: false,
                time: [],
                rechargeRules: {
                    companySelect: [{
                        trigger: 'change',
                        required: true,
                        message: '请选择需充值的运营商!'
                    }],
                    type: [{
                        trigger: 'change',
                        required: true,
                        message: '请选择充值类型!'
                    }],
                    money: [{
                            trigger: 'blur',
                            required: true,
                            message: '金额不能为空!'
                        },
                        {
                            trigger: 'blur',
                            validator: validMoney
                        }
                    ],
                    randomcode: [{
                        trigger: 'blur',
                        required: true,
                        message: '验证码不能为空!'
                    }],
                    remark: [{
                        trigger: 'blur',
                        required: true,
                        message: '备注不能为空!'
                    }]
                },
                rechargeForm: {
                    companySelect: "",
                    type: "0",
                    money: '',
                    randomcode: '',
                    remark: ''
                },
                changeMoney: false,
                timeCount:0
            }
        },
        watch: {},
        computed: {
            initMoney: function() {
                var money = "0.00";
                var regPos = /((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/;
                if (this.rechargeForm.money != "") {
                    if (regPos.test(this.rechargeForm.money)) {
                        var intPart = Number(Math.floor(this.rechargeForm.money));
                        var valueArray = this.rechargeForm.money.split(".");
                        if (intPart.toString().length < 10) {
                            if (valueArray.length == 2) {
                                var floatPart = valueArray[1].toString();
                                if (floatPart.length == 1) {
                                    money = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + "." +
                                        floatPart + "0";
                                } else if (floatPart.length == 2) {
                                    money = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + "." +
                                        floatPart;
                                } else {
                                    return "您输入的金额格式有误!"
                                }
                            } else {
                                money = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + ".00";
                            }
                        } else {
                            return "您输入的金额格式有误!"
                        }
                    } else {
                        return "您输入的金额格式有误!"
                    }
                }
                return "您输入金额:" + money + "元";
            }
        },
        mounted() {
            this.updateTable();
        },
        beforeDestroy() {},
        methods: {
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.updateTable();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.updateTable();
            },
            updateTable() {
                var params = {
                    pageId: this.currentPage,
                    size: this.pageSize,
                    searchx: 'operator'
                };
                if (this.time != null && this.time.length > 0) {
                    params.startDate = this.getStandardDate(this.time[0]);
                    params.endDate = this.getStandardDate(this.time[1]);
                }
                var thiz = this;
                const loading = this.$loading({
                    lock: true,
                    text: '获取表格数据中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                setTimeout(() => {
                    loading.close();
                }, 3000);
                axios.get(this.$store.getters.getApiValue + '/srsAgent/searchRecharge.do', {
                    params: params
                }).then(function(response) {
                    loading.close();
                    var data = response.data;
                    if (data.status == "200") {
                        thiz.tableData = data.data;
                        thiz.total = data.totalCount;
                    } else {
                        thiz.$message.error(data.message);
                    }
                }).catch(function(error) {
                    loading.close();
                    console.log(error);
                });
            },
            dateFormat(row, column) {
                var str = row[column.property];
                if (str == null || str == "") {
                    return "";
                } else {
                    return this.getStandardDate(new Date(str));
                }
            },
            getStandardDate(val) {
                var year = val.getFullYear();
                var month = val.getMonth() + 1;
                var day = val.getDate();
                var hour = val.getHours();
                var minute = val.getMinutes();
                var second = val.getSeconds();
                month = month < 10 ? "0" + month : month;
                day = day < 10 ? "0" + day : day;
                hour = hour < 10 ? "0" + hour : hour;
                minute = minute < 10 ? "0" + minute : minute;
                second = second < 10 ? "0" + second : second;
                return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
            },
            headClass({
                row,
                rowIndex
            }) {
                if (rowIndex == 0) {
                    return ''
                }
                return ''
            },
            rowClass({
                row,
                rowIndex
            }) {
                if (rowIndex % 2 == 0) {
                    return 'background:#F1F2F7;'
                } else {
                    return 'background:white;'
                }
                return ''
            },
            openDialog() {
                this.rechargeForm.companySelect = "";
                this.rechargeForm.money = "";
                this.rechargeForm.randomcode = "";
                this.rechargeForm.remark = "";
                this.changeMoney = false;
                this.timeCount=0;
                var thiz = this;
                var params = {
                    isOperator: 1
                }
                axios.get(this.$store.getters.getApiValue + '/srsAgent/getAllAgentList.do', {
                        params: params
                    })
                    .then(function(response) {
                        var data = response.data;
                        if (data.status == "200") {
                            thiz.companyList = data.data;
                            thiz.myDialog = true;
                        } else {
                            thiz.$message.error(data.message);
                        }
                    }).catch(function(error) {
                        console.log(error);
                    });
            },
            addMoney() {
                var thiz = this;
                this.$refs["rechargeForm"].validate(async valid => {
                    if (valid) {
                        var name = "";
                        for (var i = 0; i < this.companyList.length; i++) {
                            if (this.rechargeForm.companySelect == this.companyList[i].agentId) {
                                name = this.companyList[i].companyName;
                            }
                        }
                        this.$confirm('确认为' + name + '充值' + this.rechargeForm.money + '元')
                            .then(_ => {
                                axios.get(thiz.$store.getters.getApiValue +
                                    '/srsAgent/agentRecharge.do', {
                                        params: {
                                            agentId: thiz.rechargeForm.companySelect,
                                            type: thiz.rechargeForm.type,
                                            money: thiz.rechargeForm.money,
                                            randomcode: thiz.rechargeForm.randomcode,
                                            remarks: thiz.rechargeForm.remark,
                                            searchx: 'operator'
                                        }
                                    }).then(function(response) {
                                    var data = response.data;
                                    if (data.status == "200") {
                                        thiz.$message.success("充值成功!");
                                        thiz.updateTable();
                                        thiz.myDialog = false;
                                    } else {
                                        thiz.$message.error(data.message);
                                    }
                                }).catch(function(error) {
                                    console.log(error);
                                });
                            }).catch(_ => {});
                    } else {
                        this.$message.error("填写不完整或格式不正确，请确认！")
                    }
                })

            },
            // 验证码
            getVerifyCode() {
                if (this.rechargeForm.companySelect === '' || this.rechargeForm.money === '') {
                    this.$message.info("请选择需要充值的账号, 输入金额")
                    return;
                }
                //this.$refs.registerForm.validateField('mobile');
                this.timeCount=60;
                this.setBtnTimer(document.getElementById("getVerifyCode"));
            },
            setBtnTimer(btnObj) {
                btnObj.disabled = true;
                this.getCodeByApi();
                var thiz = this;
                clearInterval(timer);
                var timer = setInterval(function() {
                    if (thiz.timeCount > 0) {
                        thiz.timeCount--;
                        btnObj.innerHTML = thiz.timeCount + "s后重发";
                        btnObj.style.backgroundColor = "#CCCCCC";
                        btnObj.style.borderColor = "#CCCCCC";
                    } else {
                        btnObj.innerHTML = "获取验证码";
                        btnObj.disabled = false;
                        btnObj.style.backgroundColor = "#e6a23c";
                        btnObj.style.borderColor = "#e6a23c";
                        clearInterval(timer);
                    }
                }, 1000);
            },
            getCodeByApi() {
                var thiz = this;
                axios.get(this.$store.getters.getApiValue + '/srsAgent/sendRechargeCode.do', {
                    params: {
                        agentId: thiz.rechargeForm.companySelect,
                        money: thiz.rechargeForm.money
                    }
                }).then(function(response) {
                    var data = response.data;
                    if (data.status == "200") {
                        thiz.$message.success("发送验证消息成功");
                        thiz.changeMoney = true; // 禁止修改金额
                    } else {
                        thiz.$message.error(data.message);
                    }
                }).catch(function(error) {
                    console.log(error);
                    thiz.$message.error("系统异常,请与管理员联系!");
                });
            }
        }
    }
</script>

<style>
    .el-table {
        font-size: 12px;
        border-bottom: 1px solid #dcd8d8;
        color: black;
    }

    .el-table tr th {
        border-top: 0px;
        border-left: 0px;
        border-right: 0px;
    }

    .el-table tr td {
        border-bottom: 1px solid #dcd8d8;
    }
</style>